export enum LocalStorageFields {
    absences = "absences",
    config = "config",
    customers = "customers",
    employees = "employees",
    employeesUtilization = "employeesUtilization",
    projects = "projects",
}